import { Injectable } from '@angular/core';

import { Product } from 'idt-ecommerce-api/catalog/products/products.models';
import {
  PRODUCT_DEFAULT_PRICE_DISCOUNT_FORMAT,
  PRODUCT_DEFAULT_PRODUCT_PREWARMING_DISCOUNT_RATE_FORMAT,
  PrewarmingPriceDiscountOption,
  PriceDiscountOption
} from 'shared/models/product-prices/product-prices.models';


@Injectable({
  providedIn: 'root'
})
export class ProductsPricesService {

  public getTextFormat(
    defaultPriceFormat: string,
    priceKey: string,
    priceValue: string,
    priceWithFormat?: string,
  ): string {
    const template = priceWithFormat || defaultPriceFormat;
    return template.replace(new RegExp(`{{${priceKey}}}`, 'g'), priceValue);
  }

  public calculatePrewarmingDiscount(
    discountOption: PrewarmingPriceDiscountOption | PriceDiscountOption,
    productPrewarmingDiscountRateTextFormat: string | undefined,
    product: Product
  ): string {
    let discount: string = '';
    if (productPrewarmingDiscountRateTextFormat) {
      switch (discountOption) {
        case 'original-price': {
          discount = this.calculatePercentage(
            +product.priceInfo!.prewarming!.price || 0,
            product.priceInfo!.originalPrice || 0
          );
          break;
        }
        case 'min-price': {
          discount = this.calculatePercentage(
            +product.priceInfo!.prewarming!.price || 0,
            Math.min(
              product.priceInfo!.price || 0,
              product.priceInfo!.oldPrice || 0
            )
          );
          break;
        }
        default: {
          discount = product.priceInfo!.prewarming!.discountRate!;
          break;
        }
      }
    }

    const template = productPrewarmingDiscountRateTextFormat || PRODUCT_DEFAULT_PRODUCT_PREWARMING_DISCOUNT_RATE_FORMAT;
    return template.replace(/{{productPrewarmingDiscountRate}}/g, discount || product.priceInfo!.prewarming!.discountRate!);
  }

  public calculateActualPriceDiscount(
    discountOption: PrewarmingPriceDiscountOption | PriceDiscountOption,
    priceDiscountTextFormat: string | undefined,
    product: Product
  ): string {
    let discount: string = '';
    if (priceDiscountTextFormat) {
      switch (discountOption) {
        case 'original-price': {
          discount = this.calculatePercentage(
            product.priceInfo!.price || 0 ,
            product.priceInfo!.originalPrice || 0
          );
          discount &&= `${discount}*`;
          break;
        }
        default: {
          discount = this.calculatePercentage(
            product.priceInfo!.price || 0 ,
            product.priceInfo!.oldPrice || 0,
          );
          break;
        }
      }
    }

    const template = priceDiscountTextFormat || PRODUCT_DEFAULT_PRICE_DISCOUNT_FORMAT;
    return template.replace(/{{productPriceDiscount}}/g, discount || product.priceInfo?.discount || '');
  }

  private calculatePercentage(priceWithDiscount: number, priceWithoutDiscount: number): string {
    return (priceWithDiscount > 0 && priceWithoutDiscount > 0)
      ? `${Math.floor((1 - priceWithDiscount / priceWithoutDiscount) * 100)}%`
      : '';
  }

}
